import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[scDropdownListTmp]',
    standalone: false
})
export class ScDropdownListDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
